var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0005 11.9289V15.072C16.0006 15.297 15.9153 15.5138 15.7619 15.6784C15.6085 15.843 15.3983 15.9434 15.1738 15.9591C14.7854 15.9858 14.468 16 14.2227 16C6.3676 16 0.000488281 9.63289 0.000488281 1.77778C0.000488281 1.53244 0.0138216 1.21511 0.0413772 0.826667C0.0571304 0.602172 0.157449 0.39201 0.322091 0.238586C0.486733 0.0851616 0.703442 -0.000101718 0.928488 2.28071e-07H4.0716C4.18186 -0.000111408 4.28822 0.0407636 4.37002 0.114685C4.45183 0.188606 4.50324 0.290296 4.51427 0.4C4.53471 0.604445 4.55338 0.767111 4.57116 0.890667C4.74781 2.12349 5.10982 3.32252 5.64493 4.44711C5.72938 4.62489 5.67427 4.83733 5.51427 4.95111L3.59604 6.32178C4.76889 9.05462 6.94675 11.2325 9.6796 12.4053L11.0485 10.4907C11.1044 10.4124 11.1861 10.3563 11.2792 10.3321C11.3722 10.3079 11.4709 10.3172 11.5578 10.3582C12.6823 10.8924 13.881 11.2535 15.1134 11.4293C15.2369 11.4471 15.3996 11.4658 15.6023 11.4862C15.7118 11.4975 15.8133 11.549 15.887 11.6307C15.9608 11.7125 16.0006 11.8188 16.0005 11.9289Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.9303c7595a22b4bc32dfc21a0bbddc00.svg";
export { ForwardRef as ReactComponent };